/* eslint-disable max-lines*/

import { loadYoutubeIframeApi, YoutubeVideoAnalytics } from './youtubeVideoAnalytics';

const playerSelector = '.js-video-popup';
const defaultYoutubeTargetingCookieGroup = 'C0004';
const consentCheckInterval = 500;
let isJwplayerPopupModuleRegistered = false;

export class VideoPopup {
  static isOnPage() {
    return $(playerSelector).length !== 0;
  }

  static ensureJwplayerPopupModule() {
    // productDetail.js and video.js load independently, so PDP initializes this
    // once before its gallery can request a jwplayer item.
    if (!isJwplayerPopupModuleRegistered) {
      new VideoPopup(true);
    }
  }

  constructor(registerJwplayerModuleOnly = false) {
    this.youtubeAnalytics = null;
    this.youtubeAnalyticsRequestId = 0;
    this.load();
    if (!registerJwplayerModuleOnly) {
      this.init();
    }
  }

  load() {
    if (isJwplayerPopupModuleRegistered) {
      return;
    }

    /**
     * JW Player support for magnific popup
     */

    const currentJwplayer = {
      player: null,
      playerElement: null,
      playerId: 'mfp-jwplayer-instance',
      pendingConfig: null,

      setCurrentPlayer(player) {
        this.player = player;
      },

      setCurrentPlayerElement(playerElement) {
        this.playerElement = playerElement;
      },

      getCurrentPlayer() {
        return this.player;
      },

      getCurrentPlayerElement() {
        return this.playerElement;
      },

      reset() {
        this.player = null;
        this.playerElement = null;
        this.pendingConfig = null;
      }
    };

    const getCloseModalAriaLabel = () => {
      const videoObj = $('.js-video-popup');
      if (videoObj.length > 0) {
        const ariaLabel = videoObj.data('close-aria-label');

        return ariaLabel || 'Close';
      }

      return 'Close';
    };

    const closeBtnAriaLabel = getCloseModalAriaLabel();

    $.magnificPopup.registerModule('jwplayer', {
      options: {
        markup:
          '<div class="mfp-jw-wrapper">' +
          '<button type="button" aria-label="' + closeBtnAriaLabel + '" class="mfp-close">&times;</button>' +
          '<div id="mfp-jwplayer"></div>' +
          '</div>'
      },

      proto: {
        initJwplayer() {
          // Initialize event handlers
        },

        hideOriginalButton(element) {
          currentJwplayer.setCurrentPlayerElement(element);
          if (element) {
            element.style.display = 'none';
          }
        },

        instantiatePlayer() {
          const element = currentJwplayer.getCurrentPlayerElement();
          if (!element) {
            return;
          }

          const urlHls = element.getAttribute('data-video-url-hls');
          const urlProgressive = element.getAttribute('data-video-url-progressive') || element.getAttribute('href');
          const videoName = element.getAttribute('data-video-title') || element.getAttribute('data-video-name') || 'Video';

          currentJwplayer.pendingConfig = {
            playlist: [{
              file: urlHls || urlProgressive,
              title: videoName
            }],
            autostart: true,
            ga4analytics: true,
            controls: true,
            mute: false
          };
        },

        appendPlayerToPopup() {
          if (!currentJwplayer.pendingConfig) {
            return;
          }

          const checkInterval = setInterval(() => {
            const mfpPlayerWrapper = document.querySelector('#mfp-jwplayer');

            if (mfpPlayerWrapper) {
              clearInterval(checkInterval);

              while (mfpPlayerWrapper.firstChild) {
                mfpPlayerWrapper.removeChild(mfpPlayerWrapper.firstChild);
              }

              const existing = document.getElementById(currentJwplayer.playerId);
              if (existing) {
                existing.remove();
              }

              const playerContainer = document.createElement('div');
              playerContainer.id = currentJwplayer.playerId;

              const originalEl = currentJwplayer.getCurrentPlayerElement();
              if(originalEl) {
                  const videoTitle = originalEl.getAttribute('data-video-title') || 'Video';
                  playerContainer.setAttribute('aria-label', videoTitle);
                  playerContainer.setAttribute('role', 'presentation');
              }

              mfpPlayerWrapper.appendChild(playerContainer);

              if (typeof window.setupVideoPlayer === 'function') {
                try {
                  const player = window.setupVideoPlayer(currentJwplayer.playerId, currentJwplayer.pendingConfig);
                  currentJwplayer.setCurrentPlayer(player);
                } catch (error) {
                  // Silent error handling
                }
              }
            }
          }, 50);

          setTimeout(() => {
            clearInterval(checkInterval);
          }, 5000);
        },

        getJwplayer(item, template) {
          const that = this;
          this.updateStatus('ready');
          let isDone = false;
          let clickedElement = null;

          const magnificPopupSetup = (e) => {
            if (!isDone) {
              try {
                if ((e.type === 'mfpOpen' || e.type === 'mfpChange') && item.el && item.el[0]) {
                  clickedElement = item.el[0];
                }

                if (clickedElement) {
                  that.hideOriginalButton(clickedElement);
                  that.instantiatePlayer();
                  that.appendPlayerToPopup();
                  isDone = true;
                }
              } catch (error) {
                // Silent error handling
              }
            }
          };

          this.ev.on('mfpOpen', magnificPopupSetup);
          this.ev.on('mfpChange', magnificPopupSetup);

          this.ev.on('mfpClose', () => {
            try {
              if (currentJwplayer.getCurrentPlayer()) {
                currentJwplayer.getCurrentPlayer().remove();
              }
            } catch (e) {
              // Silent error handling
            } finally {
              const originalElement = currentJwplayer.getCurrentPlayerElement();
              if (originalElement) {
                originalElement.style.display = '';
              }

              currentJwplayer.reset();
              isDone = false;
              clickedElement = null;
            }
          });

          return template;
        }
      }
    });

    isJwplayerPopupModuleRegistered = true;

    const uglyJwplayerWrapperHack = () => {
      const videoObj = $('.js-video-popup');
      const jwChildWithPop = videoObj.find($('.js-video-popup'));
      if (jwChildWithPop.length > 0) {
        jwChildWithPop.removeClass('js-video-popup');
      }
    };

    uglyJwplayerWrapperHack();
  }

  /**
   * Returns the OneTrust group that is required for embedded YouTube playback.
   * @returns {String} OneTrust targeting cookie group id.
   */
  getYoutubeTargetingCookieGroup() {
    return window.HMSYoutubeTargetingCookieGroup || defaultYoutubeTargetingCookieGroup;
  }

  /**
   * Checks if the required YouTube targeting cookie group is currently accepted.
   * @returns {Boolean} True when YouTube embeds are allowed to load.
   */
  hasYoutubeConsent() {
    const targetingCookieGroup = this.getYoutubeTargetingCookieGroup();
    const activeGroups = window.OnetrustActiveGroups || window.OptanonActiveGroups || '';

    if (Array.isArray(activeGroups)) {
      return activeGroups.indexOf(targetingCookieGroup) !== -1;
    }

    return typeof activeGroups === 'string' && activeGroups.indexOf(targetingCookieGroup) !== -1;
  }

  /**
   * Builds the Magnific Popup iframe config for a YouTube URL.
   * @param {String} videoUrl - Original YouTube video URL.
   * @param {HTMLElement} playerElement - Element that triggered the video popup.
   * @returns {Object} Magnific Popup config.
   */
  getYoutubePopupConfig(videoUrl, playerElement) {
    const origin = encodeURIComponent(window.location.origin);

    return {
      items: {
        src: videoUrl
      },
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtu',
            // Regex is required to extract the unique 11-character YouTube video ID
            // from various URL formats (watch?v=, youtu.be/, embed/) and to
            // strip away extra parameters like timestamps (&t=) or tracking tags.
            id: (url) => {
              const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
              const match = url.match(regExp);

              return (match && match[7] && match[7].length === 11)
                ? match[7]
                : url;
            },
            src: `https://www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1&origin=${origin}`
          }
        }
      },
      callbacks: {
        open: () => {
          const iframe = $('.mfp-content iframe').get(0);
          const videoTitle = playerElement
            ? playerElement.getAttribute('data-video-title') || playerElement.getAttribute('data-video-name')
            : '';

          this.initYoutubeAnalytics(iframe, videoUrl, videoTitle);
        },
        close: () => {
          this.destroyYoutubeAnalytics();
        }
      }
    };
  }

  /**
   * Connects GA4 tracking to the YouTube iframe after consent has been granted.
   * @param {HTMLIFrameElement} iframe - Magnific Popup YouTube iframe.
   * @param {String} videoUrl - Original YouTube URL.
   * @param {String} videoTitle - CMS-provided title fallback.
   */
  initYoutubeAnalytics(iframe, videoUrl, videoTitle) {
    if (!iframe) {
      return;
    }

    const requestId = ++this.youtubeAnalyticsRequestId;

    loadYoutubeIframeApi().then(() => {
      if (requestId !== this.youtubeAnalyticsRequestId || !document.documentElement.contains(iframe)) {
        return;
      }

      this.destroyYoutubeAnalytics(false);
      this.youtubeAnalytics = new YoutubeVideoAnalytics(iframe, {
        videoUrl,
        videoTitle
      });
    }).catch(() => {
      // Analytics must not prevent normal YouTube playback.
    });
  }

  /**
   * Stops YouTube polling and releases the API player when its popup closes.
   * @param {Boolean} invalidateRequest - Prevent a pending API request from attaching.
   */
  destroyYoutubeAnalytics(invalidateRequest = true) {
    if (invalidateRequest) {
      this.youtubeAnalyticsRequestId++;
    }

    if (this.youtubeAnalytics) {
      this.youtubeAnalytics.destroy();
      this.youtubeAnalytics = null;
    }
  }

  /**
   * Reads the HBS-rendered consent template and sets the direct YouTube URL.
   * @param {String} videoUrl - Original YouTube video URL.
   * @returns {String} Consent popup markup.
   */
  getYoutubeConsentMarkup(videoUrl) {
    const $template = $('.js-youtube-video-consent-template').first();
    const $container = $('<div>');
    let $directLink;

    if (!$template.length) {
      return '';
    }

    $container.html($template.html());
    $directLink = $container.find('.js-youtube-direct-link');

    if ($directLink.length) {
      $directLink.attr('href', videoUrl);
    }

    return $container.html();
  }

  /**
   * Checks if the OneTrust preference center is currently visible.
   * @returns {Boolean} True when the OneTrust modal is open.
   */
  isCookiePreferencesOpen() {
    const $preferenceCenter = $('#onetrust-pc-sdk');

    if (!$preferenceCenter.length) {
      return false;
    }

    return $preferenceCenter.attr('aria-hidden') !== 'true'
      && $preferenceCenter.css('display') !== 'none'
      && $preferenceCenter.css('visibility') !== 'hidden';
  }

  /**
   * Opens the OneTrust cookie preferences panel when the API is available.
   */
  openCookiePreferences() {
    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
    } else if (window.Optanon && typeof window.Optanon.ToggleInfoDisplay === 'function') {
      window.Optanon.ToggleInfoDisplay();
    }
  }

  /**
   * Closes the OneTrust cookie preferences panel from our ESC handler.
   */
  closeCookiePreferences() {
    const $closeButton = $('#close-pc-btn-handler, .ot-close-icon, .onetrust-close-btn-handler').first();

    if ($closeButton.length) {
      $closeButton.trigger('click');
    } else {
      this.openCookiePreferences();
    }
  }

  /**
   * Opens the real YouTube iframe popup.
   * @param {String} videoUrl - Original YouTube video URL.
   * @param {HTMLElement} playerElement - Element that triggered the video popup.
   */
  openYoutubeVideo(videoUrl, playerElement) {
    $.magnificPopup.open(this.getYoutubePopupConfig(videoUrl, playerElement));
  }

  /**
   * Opens the cookie consent notice instead of loading the YouTube iframe.
   * @param {String} videoUrl - Original YouTube video URL.
   * @param {HTMLElement} playerElement - Element that triggered the video popup.
   */
  openYoutubeConsentPopup(videoUrl, playerElement) {
    let isConsentPopupOpen = false;
    let consentIntervalId = null;

    const stopConsentCheck = () => {
      if (consentIntervalId) {
        window.clearInterval(consentIntervalId);
        consentIntervalId = null;
      }
    };

    const openVideoAfterConsent = () => {
      if (!isConsentPopupOpen || !this.hasYoutubeConsent()) {
        return;
      }

      isConsentPopupOpen = false;
      stopConsentCheck();
      $.magnificPopup.close();

      window.setTimeout(() => {
        this.openYoutubeVideo(videoUrl, playerElement);
      }, 100);
    };

    const handleConsentPopupEscape = (event) => {
      if (event.key !== 'Escape' && event.key !== 'Esc') {
        return;
      }

      if (this.isCookiePreferencesOpen()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.closeCookiePreferences();

        return;
      }

      event.preventDefault();
      $.magnificPopup.close();
    };

    $.magnificPopup.open({
      items: {
        src: this.getYoutubeConsentMarkup(videoUrl)
      },
      type: 'inline',
      closeBtnInside: true,
      enableEscapeKey: false,
      mainClass: 'mfp-youtube-video-consent',
      callbacks: {
        open: () => {
          isConsentPopupOpen = true;
          $(document).on('keydown.youtubeConsentEscape', handleConsentPopupEscape);
          consentIntervalId = window.setInterval(openVideoAfterConsent, consentCheckInterval);

          if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
            window.OneTrust.OnConsentChanged(openVideoAfterConsent);
          }

          $('.js-youtube-cookie-preferences').off('click.youtubeConsent').on('click.youtubeConsent', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.openCookiePreferences();
          });
        },
        close: () => {
          isConsentPopupOpen = false;
          $(document).off('keydown.youtubeConsentEscape', handleConsentPopupEscape);
          stopConsentCheck();
        }
      }
    });
  }

  /**
   * Routes YouTube clicks to either the video iframe or the consent notice.
   * @param {String} videoUrl - Original YouTube video URL.
   * @param {HTMLElement} playerElement - Element that triggered the video popup.
   */
  openYoutubePopup(videoUrl, playerElement) {
    if (this.hasYoutubeConsent()) {
      this.openYoutubeVideo(videoUrl, playerElement);
    } else {
      this.openYoutubeConsentPopup(videoUrl, playerElement);
    }
  }

  init() {
    $.each($(playerSelector), (index, player) => {
      if ($(player).parents('.image-carousel').length === 0) {
        const $player = $(player);
        const videoUrl = $player?.data('youtube-url') || $player?.attr('href');
        const isYouTube = $player.hasClass('js-video-youtube');
        let config;

        if (isYouTube) {
          $player.off('click.youtubeConsent keydown.youtubeConsent');
          $player.on('click.youtubeConsent', (event) => {
            event.preventDefault();
            this.openYoutubePopup(videoUrl, player);
          });
          $player.on('keydown.youtubeConsent', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.openYoutubePopup(videoUrl, player);
            }
          });
        } else {
          config = {
            type: 'jwplayer',
            closeOnContentClick: false,
            closeBtnInside: true
          };

          $player.on('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              $player.magnificPopup('open');
            }
          });

          $player.magnificPopup(config);
        }
      }
    });
  }
}
